import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import QrTransactionTable from "../components/QrTransaction/Table";

export default function QrTransactionPage() {
  return (
    <Box sx={{ padding: "8px 0" }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h6">รายการ QR (QR Transaction)</Typography>
      </Box>
      <QrTransactionTable />
    </Box>
  );
}
